// Renders a saved Font Awesome class string ("fa-solid fa-truck") from the icon font, without loading FA's CSS.
import { Component, Input, OnChanges } from '@angular/core';
import { findOmpIcon, loadOmpIconIndex, ompIconChar } from '../../../_helpers';

@Component({
  selector: 'omp-icon-glyph',
  template: `<span *ngIf="glyph" class="omp-icon-glyph omp-icon-glyph-{{ style }}" [title]="label">{{ glyph }}</span>`,
  styles: [
    ':host { display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; }',
    'span { display: block; width: auto; font-size: 18px; line-height: 1; }',
  ],
})
export class OmpIconGlyphComponent implements OnChanges {
  @Input() icon: string;

  public glyph = '';
  public style = '';
  public label = '';

  ngOnChanges() {
    const requested = this.icon;
    this.glyph = '';
    if (requested) {
      loadOmpIconIndex().then(
        (index) => {
          const match = findOmpIcon(index, requested);
          if (match && requested === this.icon) {
            this.glyph = ompIconChar(match.unicode);
            this.style = match.style;
            this.label = match.label;
          }
        },
        () => {}
      );
    }
  }
}
